module.exports = __webpack_public_path__ + "img/main-2-old.b6a47d84.webp";